import { useEffect } from 'react';

/**
 * Add page-specific schema.org structured data (JSON-LD) to <head> while the
 * page is mounted. Keeping it per page means e.g. a FAQ's markup only appears
 * on the page where that FAQ is actually visible, as search engines require.
 */
export const useJsonLd = (id: string, data: object | object[] | null) => {
  const json = data ? JSON.stringify(data) : '';
  useEffect(() => {
    if (!json) return undefined;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.pageLd = id;
    // JSON.stringify output is safe as text; escape "<" so content can't close the script tag.
    script.textContent = json.replace(/</g, '\\u003c');
    document.head.appendChild(script);
    return () => script.remove();
  }, [id, json]);
};

export const SITE_URL = 'https://pdf-to-text.com';

export const AUTHOR = { '@type': 'Person', name: 'Li Fan', url: 'https://github.com/linkmodo' } as const;

/** FAQPage schema from visible question/answer pairs. */
export const faqSchema = (items: { q: string; a: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
});
